module.exports = __webpack_public_path__ + "static/media/iconFour.08f991c4.svg";